/**
 * Permite truncar una cadena. Si la longitud supera n, corta y añade la elipsis
 * @param {string} string Cadena a cortar
 * @param {number} n Longitud a partir de la cual cortar
 * @return {string}
 */
export const truncate = (string, n) => (string.length > n) ? string.substring(0, n) + '...' : string;

/**
 * Calcula el valor de un número x dentro de un rango deseable en base a un rango posible
 * El rango deseable (minAllowed y maxAllowed) es el rango de números que se espera como salida
 * El rango posible (min, max) es el rango de números en el que se mueve unscaledNum
 * Y por último, unscaledNum es el número a convertir.
 * @param {number} unscaledNum Número que se desea escalar
 * @param {number} minAllowed Número mínimo del rango de salida
 * @param {number} maxAllowed Número máximo del rango de salida
 * @param {number} min Número mínimo que "unscaledNum" puede alcanzar
 * @param {number} max Número máximo que "unscaledNum" puede alcanzar
 * @return {number}
 */
export const scaleBetween = (unscaledNum, minAllowed, maxAllowed, min, max) =>
    (maxAllowed - minAllowed) * (unscaledNum - min) / (max - min) + minAllowed;
